export const canAdministerCommunityOfferTopics = (
	user?: { type?: string } | null,
) => user?.type === 'SUPERADMIN';
